module.exports = __webpack_public_path__ + "static/media/orbit-orb.20356a04.webp";